export function goToWhaleCoinExplain () {
  window.location.href = 'yixinli://open_article?article_id=100468592'
}
